import { Box, Typography } from '@mui/material'
import ChipStatus from './ChipStatus'

const TitleUl = ({ ul, results = [] }) => {
  return (
    <Box className='flex gap-2 items-center justify-between'>
      <Box className='flex gap-2 items-center'>
        <Typography className='text-2xl font-bold text-primary-foreground'>{ul.ulName}</Typography>
        <ChipStatus
          status={ul?.ulStatus?.name || 'Unknown'}
          color={ul?.ulStatus?.color || 'default'}
          border={ul?.ulStatus?.border || false}
          bgColor={ul?.ulStatus?.bgColor || 'default'}
        />
      </Box>
      <Box className='flex gap-2 items-center'>
        {results?.map((result) => (
          <div key={`result-${result._id}`} className='flex gap-2 items-center justify-between'>
            <Typography className='text-sm font-bold text-primary'>{result.name}</Typography>
            <div>{result.length}</div>
          </div>
        ))}
      </Box>
    </Box>
  )
}

export default TitleUl
